import React, {Component} from 'react';
import {Col, Container, Input, Label, Progress, Row} from 'reactstrap';
import Axios from 'axios'
import HsmErrorAlert from './HsmErrorAlert'
import NormalButton from '../../components/NormalButton'
import ReactErrorTop from '../../components/ReactErrorTop'
import ReactLoadingTop from '../../components/ReactLoadingTop'
import ReactLoading from "react-loading";
import moment from "moment/moment";
import 'moment/locale/tr';


class HsmCertificateViewer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            certificateSelected: false,
            completed: false,
            hsmCertificateInfo: {},
            progressLength: 1,
            timer: null,
            manual: false
        };
        this.defaultHsmType = "akis";
        this.axios = Axios.create({
            baseURL: "http://127.0.0.1:9999"
        });

        this.loadCertificates = this.loadCertificates.bind(this);
        this.getCertificate = this.getCertificate.bind(this);
        this.setCertificate = this.setCertificate.bind(this);
        this.setCertificateResult = this.setCertificateResult.bind(this);
        this.certificateChanged = this.certificateChanged.bind(this);
    }

    componentDidMount() {
        this.loadCertificates();
    }

    setCertificate(certificateList, response, hsmType) {
        let responseList = response.data.certificate.filter((element) => {
            return element.keyUsage.some((element2) => {
                return element2 === "DIGITAL_SIGNATURE";
            });
        });
        responseList.forEach((certificate) => {
            certificate.hsmType = hsmType;
            certificateList.push(certificate);
            this.certificateChanged(certificate);
        });
    }

    setCertificateResult(certificateList, errorList, hsmTypeList) {
        this.setState({
            loading: false,
            certificateList: certificateList
        });

        if (certificateList && certificateList.length === 0 && errorList.length === hsmTypeList.length) {
            this.setState({
                alert: <HsmErrorAlert error={errorList[0]}
                                      from={this.props.from}
                                      onConfirm={() => this.setState({alert: null})}/>
            });
        }
    }

    getCertificate(certificateList, errorList, hsmTypeList, startIndex) {
        let index = startIndex;
        if (index === null) {
            index = 0;
        } else {
            index++;
        }

        if (hsmTypeList && hsmTypeList.length > index) {

            this.axios.get("/certificate?hsmtype=" + hsmTypeList[index].value)
                .then((response) => {
                    this.setCertificate(certificateList, response, hsmTypeList[index].value);
                    this.setCertificateResult(certificateList, errorList, hsmTypeList);
                    clearInterval(this.state.timer);
                })
                .catch((error) => {
                    errorList.push(error);
                    clearInterval(this.state.timer);
                    this.getCertificate(certificateList, errorList, hsmTypeList, index)
                });
        } else {
            this.setCertificateResult(certificateList, errorList, hsmTypeList);
        }
    }

    loadCertificates() {
        let hsmTypeList = [
            {label: "Aladdin", value: "aladdin"},
            {label: "Akis", value: "akis"},
            {label: "GemSafe", value: "gemsafe"},
            {label: "Seimens", value: "seimens"},
            {label: "StarCOS", value: "starcos"},
        ];
        let certificateList = [];
        let errorList = [];

        this.setState({
            loading: true,
            certificateList: null
        });

        let timer = setInterval(this.getCertificate, 5000);
        this.setState({timer});

        this.getCertificate(certificateList, errorList, hsmTypeList, null);
    }

    loadCertificatesClicked = () => {
        let url = "/certificate?hsmtype=" + ((this.props.value && this.props.value.hsmType) || this.defaultHsmType);

        this.setState({
            loading: true,
            certificateList: null
        });

        this.axios.get(url)
            .then((response) => {

                let certificateList = response.data.certificate.filter((element) => {
                    return element.keyUsage.some((element2) => {
                        return element2 === "DIGITAL_SIGNATURE";
                    });
                });

                this.setState({certificateList: certificateList});
                let selected = certificateList[0];
                selected.hsmType = ((this.props.value && this.props.value.hsmType) || this.defaultHsmType);
                this.certificateChanged(selected);
            })
            .catch((error) => {

                this.setState({
                    alert: <HsmErrorAlert error={error} onConfirm={() => this.setState({alert: null})}/>
                });
            })
            .finally(() => {
                this.setState({loading: false});
            });
    };

    certificateChanged(val) {
        let clone = Object.assign({}, this.props.value);
        clone["certificate"] = val;

        if (!clone.certificate.hsmType)
            clone.certificate.hsmType = this.defaultHsmType;

        this.setState({hsmCertificateInfo: clone});
        if (this.props.onChange) {
            this.props.onChange(clone.certificate);
        }
    }

    changed = (key, val) => {
        let clone = Object.assign({}, this.props.value);
        clone[key] = val;

        if (key === "hsmType") {
            this.setState({certificateList: null});
        }

        if (!clone.hsmType)
            clone.hsmType = this.defaultHsmType;

        if (this.props.onChange) {
            this.props.onChange(clone);
        }
    };

    render() {
        return <div>
            {this.state.alert}
            {(this.state.certificateList && this.props.value) ? this.renderDisplayCertificateSigner() : this.renderEmptyCertificateSelector()}
        </div>
    }

    renderDisplayCertificateSigner() {
        return <div>
            <div className="FormRenk">
                <Row className="FormRenk" style={{marginRight: '35px'}}>
                    {this.renderCertificateSelecter()}
                </Row>
            </div>
        </div>
    }

    renderCertificateSelecter() {

        let keyUsageMap = {
            DIGITAL_SIGNATURE: "Dijital imza",
            NON_REPUDIATION: "Reddedilememe",
            KEY_ENCIPHERMENT: "Anahtar şifreleme",
            DATA_ENCIPHERMENT: "Veri şifreleme",
            KEY_AGREEMENT: "Anahtar anlaşması",
            KEY_CERT_SIGN: "Sertifika imzalama",
            CRL_SIGN: "Sertifika iptal listesi imzalama",
            ENCIPHER_ONLY: "Sadece şifreleme",
            DECIPHER_ONLY: "Sadece çözme",
        };

        return <Container>
            <Row>
                <Col sm={12} md={6} lg={6}>
                    <Input type="select" disabled={this.props.disabled} value={this.props.value.keyId}
                           onChange={(e) => {
                               this.certificateChanged(this.state.certificateList.find((l) => (l.keyId === e.target.value)))
                           }}>
                        {this.state.certificateList.map(e => <option key={e.keyId}
                                                                     value={e.keyId}>{e.commonName}</option>)}
                    </Input>
                </Col>
                <Col sm={12} md={3} lg={3}>
                    <NormalButton disabled={this.props.disabled} color="primary" faIcon="fa-sync-alt"
                                  onClick={this.loadCertificates} style={{width: "100%"}}>
                        Sertifikaları yenile&nbsp;&nbsp;
                    </NormalButton>
                </Col>
            </Row>
            {this.props.value &&
            <Container>
                <Row>
                    <Col sm={12} md={4}>
                        <label>Ortak ad</label>
                    </Col>
                    <Col sm={12} md={8}>
                        {this.props.value.commonName}
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={4}>
                        <label>Seri no</label>
                    </Col>
                    <Col sm={12} md={8}>
                        {this.props.value.serial}
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={4}>
                        <label>Geçerlilik baslangıcı</label>
                    </Col>
                    <Col sm={12} md={8}>
                        {this.props.value.validFrom && moment(this.props.value.validFrom).isValid() ? moment(this.props.value.validFrom).format("DD-MM-YYYY HH:mm:ss") : this.props.value.validFrom}
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={4}>
                        <label>Geçerlilik sonu</label>
                    </Col>
                    <Col sm={12} md={8}>
                        {this.props.value.expiresOn && moment(this.props.value.expiresOn).isValid() ? moment(this.props.value.expiresOn).format("DD-MM-YYYY HH:mm:ss") : this.props.value.expiresOn}
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={4}>
                        <label>Anahtar kullanımı</label>
                    </Col>
                    <Col sm={12} md={8}>
                        <ul>
                            {this.props.value.keyUsage && this.props.value.keyUsage.map((element, index) => {
                                return <li key={index}>{keyUsageMap[element]}</li>
                            })}
                        </ul>
                    </Col>
                </Row>
            </Container>
            }
        </Container>
    }

    renderEmptyCertificateSelector() {
        return <Col sm={12}>
            <div style={{minHeight: '180px', position: 'relative'}}>
                {!this.state.manual && !this.state.loading &&
                <div>
                    <Row>
                        <ReactErrorTop type="usb" style={{width: '90px', height: '90px'}} transparent/>
                        <Col sm={12} md={3} lg={3}>
                            <NormalButton disabled={this.props.disabled} color="primary" faIcon="fa-sync-alt"
                                          onClick={this.loadCertificates} style={{width: "100%"}}>
                                Sertifikaları Getir&nbsp;&nbsp;
                            </NormalButton>
                        </Col>
                    </Row>
                </div>}
                {!this.state.manual && this.state.loading &&
                <ReactLoadingTop style={{width: '90px', height: '90px'}} transparent/>}
                {/*{!this.state.manual && <button id='manualBtn' onClick={() => this.setState({manual: true, alert: null})}>Manuel olarak ayarla</button>}*/}
                {this.state.manual && this.renderManual()}
            </div>
        </Col>
    }

    renderManual() {

        let hsmTypeList = [
            {label: "Akis", value: "akis"},
            {label: "GemSafe", value: "gemsafe"},
            {label: "Seimens", value: "seimens"},
            {label: "StarCOS", value: "starcos"},
            {label: "Aladdin", value: "aladdin"}
        ];

        return <Row>
            <Label sm={12} md={12} lg={12}
                   style={{
                       textAlign: "center",
                       marginBottom: "20px",
                       marginTop: "5px",
                       fontSize: "large",
                       color: "burlywood"
                   }}>
                Dikkat: Bu aşamada yardımcı uygulamayı yeniden başlatmak faydalı olacaktır.
            </Label>
            <Label sm={12} md={3} lg={3}>Akıllı kart markası</Label>
            <Col sm={12} md={5} lg={5}>
                <Input type="select" disabled={this.props.disabled}
                       value={(this.props.value && this.props.value.hsmType) || this.defaultHsmType} onChange={(e) => {
                    this.changed("hsmType", e.target.value)
                }}>
                    {hsmTypeList.map((e, i) => <option key={i} value={e.value}>{e.label}</option>)}
                </Input>
            </Col>
            <Col sm={12} md={4} lg={4}>
                <NormalButton disabled={this.props.disabled} color="primary" faIcon="fa-sync-alt"
                              onClick={this.loadCertificatesClicked} style={{width: "100%"}}>
                    Sertifikayı getir
                </NormalButton>
            </Col>
        </Row>
    }

    renderPdfName() {
        let textList = this.props.pdfName.split("#");

        return <div style={{display: "inline-block", marginRight: "8px"}}>
            <span>{textList[0]}</span>
            <span style={{fontWeight: 'bold'}}>{textList[1]}</span>
            <span>{textList[2]}</span>
            <span style={{fontWeight: 'bold'}}>{textList[3]}</span>
            <div style={{
                display: "inline-block",
                marginRight: "8px",
                position: 'absolute',
                top: '5px',
                paddingLeft: '2px'
            }}>
                <ReactLoading type="balls" color="#2c2c2c" height={12} width={12}/>
            </div>
        </div>
    }
}

export default HsmCertificateViewer;
